"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderCatalogCluezDownloadModal = void 0;
var react_1 = __importStar(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var util_1 = require("@aperza/util");
var CatalogCluezDownloadModal_1 = __importDefault(require("./CatalogCluezDownloadModal"));
var ui_1 = require("@aperza/ui");
var CatalogCluezDownloadModalLoader = function () {
    var _a = __read(react_1.useState({
        requestId: undefined,
        companyId: undefined,
        catalogId: undefined,
    }), 2), catalog = _a[0], setCatalog = _a[1];
    var subscription;
    var getMessage = ui_1.useReactiveMessage('CATALOG_DOWNLOAD_CLUEZ').getMessage;
    react_1.useEffect(function () {
        subscription = getMessage().subscribe(function (message) {
            if (message && message.companyId && message.catalogId) {
                setCatalog({
                    requestId: util_1.UUIDUtil.uuid(),
                    companyContractDisplayId: message.companyContractDisplayId,
                    companyId: +message.companyId,
                    catalogId: +message.catalogId,
                    catalogPreview: message.catalogPreview,
                });
            }
        });
        var elements = document.getElementsByClassName('catalogDownloadLink');
        if (elements && elements.length > 0) {
            elements.forEach(function (el) {
                el.addEventListener('click', function (event) {
                    var source = event.currentTarget;
                    if (source && source.dataset.company_id && source.dataset.catalog_id) {
                        event.preventDefault();
                        setCatalog({
                            requestId: util_1.UUIDUtil.uuid(),
                            companyContractDisplayId: parseInt(source.dataset.company_contract_display_id),
                            companyId: parseInt(source.dataset.company_id),
                            catalogId: parseInt(source.dataset.catalog_id),
                        });
                    }
                });
            });
        }
        if (window.aperza) {
            window.aperza.aw.catalogCluezDownloadModalLoader = new Date().getTime();
        }
    }, []);
    return (react_1.default.createElement(CatalogCluezDownloadModal_1.default, { requestId: catalog.requestId, catalogId: catalog.catalogId, companyId: catalog.companyId }));
};
exports.default = CatalogCluezDownloadModalLoader;
var renderCatalogCluezDownloadModal = function () {
    var modalId = 'aperza-catalog-cluez-download-modal';
    var modal = document.getElementById(modalId);
    if (!modal) {
        var aperzaCluezCatalogDownloadModal = document.createElement('div');
        aperzaCluezCatalogDownloadModal.id = modalId;
        document.body.appendChild(aperzaCluezCatalogDownloadModal);
        react_dom_1.default.render(react_1.default.createElement(CatalogCluezDownloadModalLoader, null), aperzaCluezCatalogDownloadModal);
    }
    else {
        console.warn("Trying to create additional modal: " + modalId);
    }
};
exports.renderCatalogCluezDownloadModal = renderCatalogCluezDownloadModal;
